<template>
  <div style="width: 100%">
    <div class="d-flex align-center mt-7">
      <v-icon
        class="mr-2"
        size="30"
        :color="$vuetify.theme.primary || '#39424e'"
        @click="back"
      >
        mdi-arrow-left-circle
      </v-icon>
      <span class="ml-3 navigation-title"> Resumo da Cotação </span>
    </div>
    <v-form ref="form">
      <v-row class="ma-0 mt-3 pa-3" dense>
        <v-col cols="12" style="padding: 0 !important">
          <h2>Informações Gerais</h2>
          <table
            class="infos-table"
            style="
              width: 80%;
              border-collapse: collapse;
              border: 1px solid #ddd;
              margin: 20px;
            "
          >
            <tr>
              <td>Nome do segurado</td>
              <td>{{ proposal.nm_segurado }}</td>
            </tr>
            <tr>
              <td>CPF do segurado</td>
              <td>
                {{
                  proposal.nr_cnpj_cpf_segurado.length > 11
                    ? proposal.nr_cnpj_cpf_segurado.substring(0, 2) +
                      "." +
                      proposal.nr_cnpj_cpf_segurado.substring(2, 5) +
                      "." +
                      proposal.nr_cnpj_cpf_segurado.substring(5, 8) +
                      "/" +
                      proposal.nr_cnpj_cpf_segurado.substring(8, 12) +
                      "-" +
                      proposal.nr_cnpj_cpf_segurado.substring(12, 14)
                    : proposal.nr_cnpj_cpf_segurado.substring(0, 3) +
                      "." +
                      proposal.nr_cnpj_cpf_segurado.substring(3, 6) +
                      "." +
                      proposal.nr_cnpj_cpf_segurado.substring(6, 9) +
                      "-" +
                      proposal.nr_cnpj_cpf_segurado.substring(9, 11)
                }}
              </td>
            </tr>
            <tr>
              <td>Renovação</td>
              <td>{{ proposal.dv_renovacao == "false" ? "Não" : "Sim" }}</td>
            </tr>
            <tr v-if="proposal.dv_renovacao == 'true'">
              <td>Renovação pela Fator Seguradora</td>
              <td>
                {{ proposal.dv_renovacao_congenere == "true" ? "Não" : "Sim" }}
              </td>
            </tr>
            <tr v-if="proposal.dv_renovacao_congenere == 'true'">
              <td>Data de retroatividade</td>
              <td>
                {{ proposal.dt_retroatividade }} ano{{
                  proposal.dt_retroatividade > 1 ? "s" : ""
                }}
              </td>
            </tr>
            <tr
              v-if="
                proposal.dv_renovacao_congenere == 'false' &&
                proposal.dv_renovacao == 'true'
              "
            >
              <td>Apólice anterior</td>
              <td>
                {{ proposal.cd_apolice_fator }}
              </td>
            </tr>
          </table>
        </v-col>
        <v-col cols="12" style="padding: 0 !important">
          <table
            class="infos-table"
            style="
              width: 80%;
              border-collapse: collapse;
              border: 1px solid #ddd;
              margin: 20px;
            "
          >
            <tr>
              <td>Início vigencia</td>
              <td>
                {{
                  proposal.dt_inicio_vigencia.substring(6, 10) +
                  "/" +
                  proposal.dt_inicio_vigencia.substring(4, 6) +
                  "/" +
                  proposal.dt_inicio_vigencia.substring(0, 4)
                }}
              </td>
            </tr>
            <tr>
              <td>Limite Máximo de Indenização</td>
              <td>
                {{
                  Number(proposal.vl_lmg).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </td>
            </tr>
          </table>
        </v-col>
        <v-col cols="12" style="padding: 0 !important">
          <table
            class="infos-table"
            style="
              width: 80%;
              border-collapse: collapse;
              border: 1px solid #ddd;
              margin: 20px;
            "
          >
            <tr>
              <td>Franquia</td>
              <td>
                {{ franquiaSelected.nm_descricao_franquia }}
              </td>
            </tr>

            <tr>
              <td>Parcela</td>
              <td>
                {{ parcelaSelected.nr_parcelas || "1" }}x
                {{
                  parcelaSelected.dv_juros == "true" ? "com juros" : "sem juros"
                }}
                de
                {{
                  Number(proposal.vl_parcela).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </td>
            </tr>
            <tr>
              <td>Vencimento parcela</td>
              <td>
                {{
                  moment(proposal.dt_vencimento_pparcela).format("DD/MM/YYYY")
                }}
              </td>
            </tr>
            <tr>
              <td>Prêmio Líquido</td>
              <td>
                {{
                  Number(proposal.vl_tarifario).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </td>
            </tr>
            <tr>
              <td>IOF</td>
              <td>7,38%</td>
            </tr>
            <tr>
              <td>Prêmio Total</td>
              <td>
                {{
                  Number(proposal.vl_total).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </td>
            </tr>
          </table>
        </v-col>
        <v-col cols="12" style="padding: 0 !important">
          <table
            class="infos-table"
            style="
              width: 80%;
              border-collapse: collapse;
              border: 1px solid #ddd;
              margin: 20px;
            "
          >
            <tr>
              <td>Produto</td>
              <td>Ramo 78 - Responsabilidade Civil Profissional</td>
            </tr>
            <tr>
              <td>Processo Susep</td>
              <td>15414.005300/2011-51</td>
            </tr>
            <tr>
              <td>Modalidade</td>
              <td>
                {{ proposal.nm_modalidade }}
              </td>
            </tr>
            <tr>
              <td>Atividade</td>
              <td>
                {{ proposal.nm_atividade }}
              </td>
            </tr>
            <tr>
              <td>ID Endosso</td>
              <td>{{ proposal.id_endosso }}</td>
            </tr>
            <tr>
              <td>Status da proposta</td>
              <td>{{ proposal.nm_status_proposta }}</td>
            </tr>
          </table>
        </v-col>
        <v-col cols="12" class="mt-5">
          <h2>Questionários</h2>
        </v-col>
        <v-col cols="12">
          <table class="questions">
            <thead>
              <tr>
                <th>Questão</th>
                <th>Resposta</th>
                <th>Justificativa</th>
              </tr>
            </thead>
            <tbody style="width: 100%">
              <tr
                v-for="question in questions"
                :key="question.id_pergunta"
                style="width: 100%"
              >
                <td style="width: 45%">{{ question.nm_pergunta }}</td>
                <td style="width: 10%; text-align: center">
                  {{ question.resposta ? "Sim" : "Não" }}
                </td>
                <td style="width: 45%; word-wrap: break-word">
                  {{ question.nm_justificativa || "Sem informações" }}
                </td>
              </tr>
            </tbody>
          </table>
        </v-col>

        <v-col cols="12" class="mb-5">
          <v-img
            src="../../../../assets/fator.jpg"
            contain
            height="100px"
            width="200px"
          ></v-img>
          <h2>Coberturas</h2>

          <v-expansion-panels>
            <p style="font-size: 15px">
              A cobertura assegurada pela apólice de seguro emitida pela Fator
              Seguradora está condicionada ao pagamento do prêmio. O não
              pagamento do prêmio (à vista ou parcelado), acarretará o
              automático cancelamento da contratação da apólice, de acordo com
              seus termos e condições.
            </p>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <strong>Coberturas Básicas</strong>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <table class="table-coverages">
                  <thead>
                    <tr>
                      <th style="border: 1px solid #ddd" class="text-left pa-3">
                        Nome da cobertura
                      </th>
                      <th style="border: 1px solid #ddd" class="text-left pa-3">
                        Sublimite
                      </th>
                      <th style="border: 1px solid #ddd" class="text-left pa-3">
                        Franquia
                      </th>
                      <th
                        style="border: 1px solid #ddd"
                        class="text-center pa-3"
                      >
                        Detalhes
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(coverage, i) in coverages.basic_coverages"
                      :key="i"
                    >
                      <td class="text-left pl-3">{{ coverage.name }}</td>
                      <td class="text-left pl-3">{{ coverage.sublimit }}</td>
                      <td class="text-left pl-3">{{ coverage.franquia }}</td>
                      <td class="text-center">
                        <v-icon
                          @click="openDialog(coverage)"
                          :color="$vuetify.theme.primary || '#34d2c7'"
                          >mdi-eye</v-icon
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <strong>Extensões de Coberturas</strong>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <table class="table-coverages">
                  <thead>
                    <tr>
                      <th style="border: 1px solid #ddd" class="text-left pa-3">
                        Nome da cobertura
                      </th>
                      <th style="border: 1px solid #ddd" class="text-left pa-3">
                        Sublimite
                      </th>
                      <th style="border: 1px solid #ddd" class="text-left pa-3">
                        Franquia
                      </th>
                      <th style="border: 1px solid #ddd" class="text-left pa-3">
                        Detalhes
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(coverage, i) in coverages.extesions_coverages"
                      :key="i + 1"
                    >
                      <td class="text-left pl-3">
                        <span>{{ coverage.name }}</span>
                      </td>
                      <td class="text-left pl-3">
                        <span>{{ coverage.sublimit }}</span>
                      </td>
                      <td class="text-left pl-3">
                        <span>{{ coverage.franquia }}</span>
                      </td>
                      <td class="text-center">
                        <v-icon
                          @click="openDialog(coverage)"
                          :color="$vuetify.theme.primary || '#34d2c7'"
                          >mdi-eye</v-icon
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-dialog
            max-width="700px"
            v-model="coverageDialog"
            v-if="coverageDialog"
          >
            <v-card class="pa-4">
              <v-card-title class="headline">
                {{ currentCoverage.name }}
              </v-card-title>
              <v-card-text v-html="currentCoverage.description"> </v-card-text>
              <v-divider class="mx-4"></v-divider>
              <p class="d-flex flex-column pa-4">
                <span
                  ><strong>Sublimite: </strong>
                  {{ currentCoverage.sublimit }}</span
                >
                <span
                  ><strong>Franquia: </strong>
                  {{ currentCoverage.franquia }}</span
                >
              </p>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  :color="$vuetify.theme.primary || '#34d2c7'"
                  style="
                    text-transform: none;
                    color: var(--custom-white-second-color);
                  "
                  @click="coverageDialog = false"
                >
                  Fechar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>

        <v-col cols="12" class="pl-6 mb-4">
          <div>
            <strong>Observação: </strong>
            <p style="font-size: 15px" class="mt-2">
              Este seguro é emitido pela Fator Seguradora S/A. – CNPJ:
              33.061.862/0001-83 - RUA DOUTOR EDUARDO DE SOUZA ARANHA, 387 5º
              ANDAR E CJ. 62 - 04543-121 - VILA NOVA CONCEIÇÃO - SÃO PAULO - SP
              - (11) 3709-3000 - (11) 3709-3050 - SAC: 0800-77-07229 - Ouvidoria
              Fator: 0800-77-32867 ou memorize: 0800-77-FATOR
              <a href="http://www.consumidor.gov.br">www.consumidor.gov.br</a>
              com o número do processo SUSEP descrito neste documento. As
              condições do produto poderão ser acessadas a qualquer tempo no
              site da SUSEP
              <a href="www.susep.gov.br">(www.susep.gov.br)</a> com o número do
              processo SUSEP descrito neste documento.
            </p>
            <p style="font-size: 15px">
              Condições Gerais (arquivo anexo):
              <a
                class="ml-2"
                href="https://keener.blob.core.windows.net/public/Condicoes_Gerais.pdf"
                download="Condições Gerais.pdf"
                target="_blank"
                >Clique aqui</a
              >
            </p>
          </div>

          <v-card class="pa-5">
            <div class="d-flex align-center justify-start">
              <v-checkbox
                v-model="acceptTermsOfContract"
                :color="$vuetify.theme.primary || '#00C7BA'"
              ></v-checkbox>
              <span style="font-size: 13px; line-height: 1.4 !important">
                Declaro que li compreendi e concordei com todos os termos e
                condições da apólice de seguro a ser emitida pela Fator
                Seguradora, com base nos dados apresentados por mim na proposta
                de segurom os quais foram, por sua vez, prévia e devidamente
                confirmados pelo meu cliente/Segurado, que manifestou expressa e
                inequivoca concordância com a respectiva emissão.
              </span>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" class="d-flex justify-end">
          <v-btn
            :style="
              $vuetify.theme.primary
                ? `color: var(--custom-white-second-color) !important; background-color: ${$vuetify.theme.primary} !important;`
                : 'color: var(--custom-white-second-color) !important;'
            "
            class="primary-button mb-3 mr-2"
            :loading="loadingDownload"
            @click="generateQuotation"
          >
            Baixar Cotação
            <v-icon class="ml-2">mdi-tray-arrow-down</v-icon>
          </v-btn>
          <v-btn
            :style="
              $vuetify.theme.primary
                ? `color: var(--custom-white-second-color) !important; background-color: ${$vuetify.theme.primary} !important;`
                : 'color: var(--custom-white-second-color) !important;'
            "
            class="primary-button mb-3"
            :loading="loading"
            @click="submit"
          >
            Contratar
            <v-icon class="ml-2">mdi-arrow-right-bold-circle-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-dialog
      v-model="termsDialog"
      persistent
      style="border-radius: 25px !important"
      width="600"
    >
      <v-card
        class="text-left pa-4"
        width="100%"
        v-show="termsDialog"
        color="#f5f5f5"
        style="border-radius: 25px !important"
      >
        <strong style="font-size: 20px" class="mb-6"
          >Termos de Aderência à LGPD</strong
        >
        <p
          style="
            font-size: 13px;
            height: 150px !important;
            overflow-y: scroll;
            border: 1px solid #00c7ba;
            padding: 7px;
            border-radius: 10px;
            margin-top: 0.7rem;
            margin-bottom: 0 !important;
          "
        >
          O(A) Corretor(a) de seguros que subscreve a presente proposta possui
          cadastro ativo junto à Superintendência de Seguros Privados – SUSEP,
          nos termos da Circular SUSEP nº 602/2020, e observa todas as normas
          legais e infralegais a que estiver sujeito pelo exercício da sua
          profissão, em especial: (i) a Circular da SUSEP nº 605/2020, que trata
          da guarda de documentos e armazenamento de dados; (ii) a Lei nº
          13.709/2018 (LGPD) sobre proteção e tratamento de dados pessoais;
          (iii) a Circular SUSEP 612/2020 e Lei nº 9.613/1998 relacionadas à
          prevenção e combate dos crimes de “lavagem” ou ocultação de bens,
          direitos e valores; e (iv) a Resolução CNSP nº 382/2020, que trata do
          relacionamento com os adquirentes de produtos securitários. Em vista
          disso, tem ciência de que deve disponibilizar, formalmente, aos
          clientes, o montante de sua comissão/remuneração pela intermediação da
          apólice, nos termos das normas aplicáveis. <br />
        </p>
        <div class="pa-4 d-flex justify-center flex-column align-center">
          <v-alert
            class="d-flex align-center"
            :color="$vuetify.theme.primary || '#00c7ba'"
            type="info"
            style="
              font-size: 14px;
              color: var(--custom-white-second-color) !important;
            "
          >
            Está ciente e de acordo que as informações prestadas serão tratadas
            em conformidade com os termos?
          </v-alert>
          <v-btn
            style="
              height: 30px !important;
              text-transform: none !important;
              color: var(--custom-white-second-color) !important;
              width: 100%;
            "
            class="mr-2"
            :color="$vuetify.theme.primary || '#00c7ba'"
            @click="
              termsDialog = false;
              acceptLGPD = true;
            "
            >Estou Ciente
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import ApiService from "../../../../services/ApiService";
import GeneralServices from "../../../../services/GeneralServices";
import coverages from "../../../../assets/coverages.json";
export default {
  data() {
    return {
      moment,
      api: new ApiService(),
      generalService: new GeneralServices(),
      result: null,
      proposal: null,
      parcelas: null,
      franquias: null,
      loading: false,
      parcelaSelected: null,
      franquiaSelected: null,
      questions: null,
      acceptTermsOfContract: false,
      coverages,
      loadingDownload: false,
      coverageDialog: false,
      currentCoverage: null,
      insured: null,
      termsDialog: false,
      viewTerms: false,
      acceptLGPD: false,
    };
  },
  created() {
    this.questions = JSON.parse(localStorage.getItem("questions"));
    this.result = JSON.parse(localStorage.getItem("resultProposal"));
    this.insured = JSON.parse(localStorage.getItem("user"));
    this.proposal = {
      ...JSON.parse(localStorage.getItem("proposal")),
      ...this.result.proposal,
    };
    console.log(this.proposal);

    this.parcelas = this.result.parcelas;
    this.franquias = this.result.franquias;
    this.parcelaSelected = this.parcelas.find(
      (x) => x.nr_parcelas == this.proposal.nr_qtd_parcelas
    ) || { nr_parcelas: "1" };

    this.franquiaSelected = this.franquias.find(
      (x) => x.id_franquia == this.proposal.id_franquia
    );
  },
  methods: {
    back() {
      if (this.proposal.dv_renovacao == "true") {
        this.$emit("back");
        this.$emit("back");
      } else {
        this.$emit("back");
      }
    },
    async submit() {
      try {
        if (this.acceptTermsOfContract) {
          if (this.acceptLGPD) {
            this.loading = true;
            const responseReport = await this.api.post("generate-quotation", {
              questions: this.questions,
              proposal: this.proposal,
              franquiaSelected: this.franquiaSelected,
              parcelaSelected: this.parcelaSelected,
              coverages: this.coverages,
              socio_img: this.$store.state.socio?.logo || null,
            });

            const report = responseReport.data.data;

            await this.api
              .post("emit-apolice", {
                id_endosso: this.proposal.id_endosso,
                token: localStorage.getItem("token"),
                id_pessoa_corretor: this.proposal.id_pessoa_corretor,
                insured: {
                  name: this.insured.nm_pessoa,
                  email: this.insured.nm_email,
                },
                queryInfos: JSON.parse(localStorage.getItem("queryInfos")),
                report,
              })
              .then(async (response) => {
                if (response.cd_retorno != 0) {
                  console.log(response);
                  this.$toast.error(
                    response.nm_retorno || "Erro ao emitir apólice"
                  );
                  this.loading = false;
                } else {
                  this.$toast.success("Apólice emitida com sucesso!");
                  await this.generalService.saveSessionInfo({
                    hired: true,
                    otherData: {
                      id_endosso: this.proposal.id_endosso,
                      token: localStorage.getItem("token"),
                      id_pessoa_corretor: this.proposal.id_pessoa_corretor,
                      insured: {
                        name: this.insured.nm_pessoa,
                        email: this.insured.nm_email,
                      },
                      queryInfos: JSON.parse(
                        localStorage.getItem("queryInfos")
                      ),
                      report,
                    },
                  });
                  this.loading = false;
                  this.$emit("next", 4);
                }
              })
              .catch(() => {
                // this.$toast.error("Erro ao emitir apólice");
                localStorage.setItem(
                  "apiErrorDescription",
                  "Erro ao emitir a apólice!"
                );
                this.loading = false;
              });
            this.loading = false;
          } else {
            this.termsDialog = true;
          }
        } else {
          this.$toast.info("É necessário aceitar os termos do contrato");
        }
      } catch (error) {
        localStorage.setItem(
          "apiErrorDescription",
          "Erro ao emitir a apólice!"
        );
      }
    },
    openDialog(coverage) {
      this.currentCoverage = coverage;
      this.coverageDialog = true;
    },

    closeDialog() {
      this.coverageDialog = false;
      this.currentCoverage = null;
    },
    async generateQuotation() {
      this.loadingDownload = true;
      await this.api
        .post("generate-quotation", {
          questions: this.questions,
          proposal: this.proposal,
          franquiaSelected: this.franquiaSelected,
          parcelaSelected: this.parcelaSelected,
          coverages: this.coverages,
          socio_img: this.$store.state.socio?.logo || null,
        })
        .then((response) => {
          const a = document.createElement("a");
          a.href = `data:application/pdf;base64,${response.data.data}`;
          a.download = "Resumo Cotação.pdf";
          a.click();
          this.loadingDownload = false;
        })
        .catch(() => {
          localStorage.setItem(
            "apiErrorDescription",
            "Erro ao gerar o pdf da cotação!"
          );
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.infos-table tr td {
  padding: 5px;
  border: 1px solid #ccc;
}

.infos-table tr td:first-child {
  font-weight: bold;
}

.infos-table tr td:last-child {
  padding-left: 10px;
}

.questions {
  width: 90%;
  border-collapse: collapse;
  border: 1px solid #ddd;
  margin: 20px;
}

.questions tr td:first-child {
  font-weight: bold;
}

.questions thead tr th {
  padding: 5px;
  border: 1px solid #ddd;
  font-weight: bold;
}

.questions tbody tr td {
  padding: 5px;
  border: 1px solid #ddd;
}

.table-coverages {
  width: 80%;
  border-collapse: collapse;
  border: 1px solid #ddd;
  margin: 20px;
}

.table-coverages tr td {
  font-weight: normal !important;
  border: 1px solid #ddd;
  padding: 5px;
}
</style>
